"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HTTPClient = void 0;
const Enums_1 = require("./Enums");
const node_fetch_1 = require("node-fetch");
const NetError_1 = require("./NetError");
class HTTPClient {
    /** Http client for SwaggerAPI_GS and for use */
    constructor(apiHost) {
        this._addHeaders = {};
        this._codeHandlers = new Map();
        this.httpMethods = Enums_1.HTTPMethods;
        this.httpCodes = Enums_1.HTTPCodes;
        this.apiHost = apiHost;
    }
    /** Set header for every request */
    setHeader(name, value) {
        if (value)
            this._addHeaders[name] = value;
        else
            delete this._addHeaders[name];
    }
    /** Set additional handler for specific invalid responce code */
    addInvalidResponceCodeHandler(code, handler) {
        if (!this._codeHandlers.has(code))
            this._codeHandlers.set(code, []);
        this._codeHandlers.get(code).push(handler);
    }
    /** Fetch get request */
    get(url, additionalHeaders = {}, validCodes = [this.httpCodes.OK]) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.process(this.httpMethods.GET, url, '', additionalHeaders, validCodes);
        });
    }
    ;
    /** Fetch post request */
    post(url, data = '', additionalHeaders = {}, validCodes = [this.httpCodes.OK]) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.process(this.httpMethods.POST, url, data, additionalHeaders, validCodes);
        });
    }
    ;
    /** Fetch put request */
    put(url, data, additionalHeaders = {}, validCodes = [this.httpCodes.OK]) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.process(this.httpMethods.PUT, url, data, additionalHeaders, validCodes);
        });
    }
    ;
    /** Fetch delete request */
    delete(url, additionalHeaders = {}, validCodes = [this.httpCodes.OK]) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.process(this.httpMethods.DELETE, url, '', additionalHeaders, validCodes);
        });
    }
    ;
    /** Fetch request */
    process(method = this.httpMethods.GET, url = '', data = '', additionalHeaders = {}, validCodes = [this.httpCodes.OK]) {
        return __awaiter(this, void 0, void 0, function* () {
            let response;
            try {
                const headers = {};
                for (const key in this._addHeaders)
                    headers[key] = this._addHeaders[key];
                for (const key in additionalHeaders)
                    headers[key] = additionalHeaders[key];
                const request = {
                    method: method,
                    headers: headers
                };
                if ((method !== this.httpMethods.GET) && (method !== this.httpMethods.DELETE))
                    request.body = data;
                response = yield node_fetch_1.default(this.apiHost + url, request);
            }
            catch (e) {
                console.error(e);
                const proccessed = yield this._inviteCodeHandlers(this.httpCodes.ConnectionTimedOut);
                if (proccessed)
                    throw new NetError_1.NetError(Enums_1.HTTPCodes.ConnectionTimedOut, undefined, true);
                throw new NetError_1.NetError(Enums_1.HTTPCodes.ConnectionTimedOut);
            }
            if (validCodes.indexOf(response.status) < 0) {
                const proccessed = yield this._inviteCodeHandlers(response.status, response);
                if (proccessed)
                    throw new NetError_1.NetError(response.status, undefined, true);
                const text = yield response.text();
                throw new NetError_1.NetError(response.status, text);
            }
            return response;
        });
    }
    ;
    _inviteCodeHandlers(code, response = undefined) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this._codeHandlers.has(code))
                for (const handler of this._codeHandlers.get(code)) {
                    const proccessed = yield handler(response);
                    if (proccessed)
                        return proccessed;
                }
            return false;
        });
    }
}
exports.HTTPClient = HTTPClient;
//# sourceMappingURL=HTTPClient.js.map